/**
 * Router state carried from a « Mes sinistres » row to the claim detail
 * (`/sinistres/:idSin`): the list already knows the insured, the product and
 * the reference, so the detail header can show them before (or without)
 * `WS2_EA_FIC_SIN`. A deep link has no state — the record alone is used.
 */

import type { ClaimListRow } from '../../api/claimsService';

export interface ClaimRouteState {
  /** `ASSURE` of the list row. */
  assure: string | null;
  /** `LIB_BR` of the list row. */
  produit: string | null;
  /** `NCBT_SIN` of the list row. */
  reference: string | null;
}

/** The router state of a list row. */
export function claimRouteStateOf(row: ClaimListRow): ClaimRouteState {
  return { assure: row.assure, produit: row.produit, reference: row.reference };
}

function stringField(record: Record<string, unknown>, key: keyof ClaimRouteState): string | null {
  const value = record[key];
  return typeof value === 'string' && value.trim() !== '' ? value.trim() : null;
}

/** Read a {@link ClaimRouteState} off `location.state` (anything else ⇒ all `null`). */
export function readClaimRouteState(state: unknown): ClaimRouteState {
  if (typeof state !== 'object' || state === null) {
    return { assure: null, produit: null, reference: null };
  }
  const record = state as Record<string, unknown>;
  return {
    assure: stringField(record, 'assure'),
    produit: stringField(record, 'produit'),
    reference: stringField(record, 'reference'),
  };
}
